import React, { PureComponent } from 'react';
import { isNil } from 'lodash';

import Popover from 'components/popover/Popover';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

applyTranslations(require('./system-message.i18n.json'));

type Props = {
  time: string
};

class SystemMessage<T = {}> extends PureComponent<Props & T> {
  renderTooltip(tooltip) {
    return Boolean(tooltip) && (
      <Popover
        questionMarkCustomSize={{
          width: 12,
          height: 12
        }}
        showQuestionMark
        contentType="text"
        classNameWrapper="messages-system-message__tooltip"
      >
        <div
          className="messages-system-message__tooltip-title"
          dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(tooltip) }}
        />
      </Popover>
    );
  }

  renderIcon(name = 'letter-inside-circle-custom-fg') {
    return (
      <div className="messages-system-message__avatar">
        <SVGDynamicIcon
          name={name}
          width={55}
          height={55}
          customColor="blue"
        />
      </div>
    );
  }

  renderDisclaimer(disclaimer, disclaimerTooltip?) {
    return (
      <div className="messages-system-message__disclaimer">
        <span dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(disclaimer) }} />
        {this.renderTooltip(disclaimerTooltip)}
      </div>
    );
  }

  renderFooter() {
    const { time } = this.props;

    if (isNil(time)) {
      return null;
    }

    return (
      <div className="messages-system-message__footer">
        {`${__t('system_message.footer')} ${time}`}
      </div>
    );
  }

  renderActions(actions: React.ReactNode): React.ReactNode {
    return (
      <div>
        {actions}
      </div>
    );
  }
}

export default SystemMessage;
